import { render, staticRenderFns } from "./crudCurrency.vue?vue&type=template&id=9b5881ce&"
import script from "./crudCurrency.vue?vue&type=script&lang=js&"
export * from "./crudCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports